import React, { useState } from "react";
import "./Resources.css"; // We'll define our styles here

function Resources() {
  // Local state to track whether the modal is open
  const [isModalOpen, setModalOpen] = useState(false);

  // Functions to open and close the modal
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div className="content-container resources-page">
      <h2>Resources</h2>
      <a href="brucelee">Wong Jack Man vs. Bruce Lee 1980 article</a>
      The Story Behind the Wong Jack Man vs Bruce Lee Fight, by Michael Dorgan
      <br />
      <br />
      <a href="wong">Wong Jack Man vs. Bruce Lee 2017 article</a>
      Interview with Wong Jack Man about the film "Birth of the Dragon"
      <br />
      <br />
      <a href="photos">EBM / Oakland Sanda Team</a> Photo Gallery
      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>EBM Pictures over the years</h3>
            <p>This modal is opened and closed using React state.</p>

            {/* Close button */}
            <button onClick={closeModal} className="close-modal-btn">
              Close
            </button>
          </div>
        </div>
      )}
      <br />
      <br />
      <a href="https://forms.gle/iBdSjcaRsHPWthbD6" target="whole">
        contact us
      </a>
    </div>
  );
}

export default Resources;
